import React from "react";
import MyHealthComponent from "./MyHealthComponent";

import { useResources } from "@aetonix/hooks";

export default function BloodPressure(props) {
	const {
		localize,
	} = useResources();

	var model = props.model;
	var bloodpressure = model.bloodpressure;

	var cumulative = bloodpressure.cumulative;
	var reverse_cumulative = bloodpressure.reverse; // needed for chart
	var readFromDevice = props.readFromDevice;

	var today = null;
	var today2 = today2;
	var section = model.page;
	// Note: There is actually a invisble space at the end for formatting purposes
	var textformat = "{systolic}/{diastolic}\n{bpPulserate}​";

	// Sets up the format to the 'today' button
	if (cumulative.length) {
		var graphdata = adjust_time(reverse_cumulative).slice(-10); // for chart
		today = cumulative[0].history.systolic + "/" + cumulative[0].history.diastolic;
		today2 = cumulative[0].history.bpPulserate || "--";

		var pulseratedata = adjust_time_pulserate(reverse_cumulative.filter((item) => item.history.bpPulserate)).slice(-10);
	}

	return (
		<MyHealthComponent
			model={model}
			section={section}
			textformat={textformat}
			latestReading={today}
			latestSecondaryReading={today2}
			reverseEntries={graphdata}
			activeModel={bloodpressure}
			readFromDevice={readFromDevice}
			xaxis={"x"}
			yaxis={"y"}
			bar
			secondaryGraph={pulseratedata}
			secondaryGraphXLabel={localize("graphlabels.pulserate.xaxis")}
			secondaryGraphYLabel={localize("graphlabels.pulserate.yaxis")}
			secondaryGraphTitle={localize("graphlabels.pulserate.title")}
			secondaryBar={false}
		/>
	);
}

function adjust_time(data) {
	var adjusted = data.map(function (item) {
		var time = time_label(item.updated_at, false);
		var systolic =
			typeof item.history.systolic === "string" ? parseFloat(item.history.systolic) : item.history.systolic;
		var diastolic =
			typeof item.history.diastolic === "string" ? parseFloat(item.history.diastolic) : item.history.diastolic;
		return {
			x: time,
			y: systolic,
			y0: diastolic,
			width: 5,
		};
	});
	return adjusted;
}

function adjust_time_pulserate(data) {
	var adjusted = data.map(function (item) {
		var time = time_label(item.updated_at, false);
		var pulseHistory = item.history.bpPulserate;
		var pulserate = 0;

		if (pulseHistory)
			if (typeof pulseHistory === "string") pulserate = parseFloat(pulseHistory);
			else pulserate = pulseHistory;

		return {
			x: time,
			y: pulserate,
		};
	});
	return adjusted;
}

function time_label(data, forBoxGraphic) {
	var parsed = time_parse(data, forBoxGraphic);

	return parsed.month + "-" + parsed.day + "  " + parsed.time;
}

function time_parse(data, forBoxGraphic) {
	var date = new Date(data);
	var month = date.getMonth() + 1;
	var day = date.getDate();
	day = two_digit(day);
	month = two_digit(month);
	var hours = two_digit(date.getHours());
	var minutes = two_digit(date.getMinutes());
	var seconds = forBoxGraphic ? "" : ":" + two_digit(date.getSeconds());
	var time = hours + ":" + minutes + seconds;

	return {
		month: month,
		day: day,
		time: time,
	};
}

function two_digit(data) {
	var item = data < 10 ? "0" + data : data;
	return item;
}
